import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { ListCustomCell } from '@shared/modules/list/interfaces/list-custom-cell.interface';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'project-created-cell',
  templateUrl: './project-created-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SharedModule]
})
export class ProjectCreatedCellComponent implements ListCustomCell {
  @ViewChild('template') template;
}
